// cart-drawer.js (patched)
// Goal: Ensure any add-to-cart form submits via AJAX and opens the lateral cart drawer,
// including forms rendered inside collection grids.

(function () {
  'use strict';

  function getDrawer() {
    return document.getElementById('cart-drawer');
  }

  function setBadgeCount(count) {
    var badge = document.getElementById('cart-drawer-count');
    if (!badge) return;

    var n = parseInt(count, 10) || 0;
    if (n <= 0) {
      badge.classList.remove('visible');
      badge.innerHTML = '0';
      badge.setAttribute('data-header-cart-count', '0');
      return;
    }

    badge.classList.add('visible');
    badge.innerHTML = String(n);
    badge.setAttribute('data-header-cart-count', String(n));
  }

  async function fetchCart() {
    var res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return await res.json();
  }

  async function renderDrawerFromSection() {
    var drawer = getDrawer();
    if (!drawer) return;

    // Use a clean URL to avoid issues with existing query params (e.g. ?variant=...)
    var url = '/?section_id=cart-drawer&time=' + Date.now();
    var res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('section fetch failed');

    var html = await res.text();
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newDrawer = doc.getElementById('cart-drawer');
    if (newDrawer) {
      drawer.innerHTML = newDrawer.innerHTML;
    }
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('open');
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('open');
  }

  async function updateCartItem(line, quantity) {
    var payload = {
      updates: {}
    };
    payload.updates[String(line)] = quantity;

    var res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error('cart/update.js failed');

    var cart = await res.json();
    setBadgeCount(cart.item_count);
    await renderDrawerFromSection();
    openDrawer();
  }

  async function addToCart(formData) {
    // POST add
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    });

    if (!res.ok) {
      // Shopify returns JSON errors; try to log them
      try {
        var err = await res.json();
        console.error('Add to cart error:', err);
      } catch (e) {
        console.error('Add to cart failed');
      }
      throw new Error('cart/add.js failed');
    }

    // Re-sync with real cart state
    var cart = await fetchCart();
    setBadgeCount(cart.item_count);
    await renderDrawerFromSection();
    openDrawer();
  }

  // Drawer interactions (event delegation so it survives innerHTML swaps)
  function initDrawerDelegation() {
    var drawer = getDrawer();
    if (!drawer || drawer.__bebesitDelegation) return;
    drawer.__bebesitDelegation = true;

    drawer.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('#close-cart-drawer');
      if (closeBtn) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      var inc = e.target.closest('.increase-quantity');
      if (inc) {
        e.preventDefault();
        var line = inc.getAttribute('data-item-id');
        var input = drawer.querySelector('.quantity-input[data-item-id="' + line + '"]');
        var current = input ? parseInt(input.value, 10) || 0 : 0;
        var next = current + 1;
        if (input) input.value = String(next);
        updateCartItem(line, next).catch(function (err) { console.error(err); });
        return;
      }

      var dec = e.target.closest('.decrease-quantity');
      if (dec) {
        e.preventDefault();
        var line2 = dec.getAttribute('data-item-id');
        var input2 = drawer.querySelector('.quantity-input[data-item-id="' + line2 + '"]');
        var current2 = input2 ? parseInt(input2.value, 10) || 0 : 0;
        var next2 = Math.max(0, current2 - 1);
        if (input2) input2.value = String(next2);
        updateCartItem(line2, next2).catch(function (err) { console.error(err); });
        return;
      }

      var rem = e.target.closest('.css-button-remove');
      if (rem) {
        e.preventDefault();
        var line3 = rem.getAttribute('data-item-id');
        updateCartItem(line3, 0).catch(function (err) { console.error(err); });
        return;
      }

      var right = e.target.closest('#css-arrow-right');
      if (right) {
        e.preventDefault();
        var el = document.getElementById('css-products-upsell-container');
        if (!el) return;
        var item = document.getElementsByClassName('css-upsell-item');
        var w = (item.length > 0 ? item.item(0).offsetWidth : 200) + 10;
        el.scrollLeft += w;
        return;
      }

      var left = e.target.closest('#css-arrow-left');
      if (left) {
        e.preventDefault();
        var el2 = document.getElementById('css-products-upsell-container');
        if (!el2) return;
        var item2 = document.getElementsByClassName('css-upsell-item');
        var w2 = (item2.length > 0 ? item2.item(0).offsetWidth : 200) + 10;
        el2.scrollLeft -= w2;
        return;
      }
    }, true);
  }

  // Global ATC interception (delegation so it works on dynamically-rendered cards)
  function initGlobalATCInterceptor() {
    if (document.__bebesitATCInterceptor) return;
    document.__bebesitATCInterceptor = true;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;

      var action = form.getAttribute('action') || '';
      // Normalize action (can be relative or full URL)
      try {
        var url = new URL(action, window.location.origin);
        action = url.pathname;
      } catch (_) {
        // keep as-is
      }

      var isAdd = action === '/cart/add' || form.classList.contains('css-form-add2cart');
      if (!isAdd) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      initDrawerDelegation();

      var submitBtn = form.querySelector('[type="submit"], button, input[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      addToCart(new FormData(form))
        .catch(function (err) { console.error(err); })
        .finally(function () {
          if (submitBtn) {
            setTimeout(function () { submitBtn.disabled = false; }, 400);
          }
        });
    }, true);
  }

  
  function initCartIconInterceptor() {
    if (document.__bebesitCartIconInterceptor) return;
    document.__bebesitCartIconInterceptor = true;

    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!link) return;

      // Intercept header cart icon/link
      var href = (link.getAttribute('href') || '').trim();
      var isCartHref = href === '/cart' || href.indexOf('/cart?') === 0 || href.indexOf('/cart#') === 0;

      var isExplicitTrigger =
        link.id === 'open-cart-drawer' ||
        link.getAttribute('data-open-cart-drawer') === 'true' ||
        link.classList.contains('site-header-cart-button') ||
        link.classList.contains('site-header-cart-link');

      var inHeader =
        !!link.closest('.site-header') ||
        !!link.closest('[data-section-type="static-header"]') ||
        !!link.closest('#shopify-section-static-header') ||
        !!link.closest('#shopify-section-static-minimal-header') ||
        !!link.closest('header');

      if (!(isExplicitTrigger || (isCartHref && inHeader))) return;

      // If we're already on /cart, allow normal behavior
      if (window.location && window.location.pathname && window.location.pathname.indexOf('/cart') === 0) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      // Make sure drawer handlers exist
      initDrawerDelegation();

      (async function () {
        try {
          var cart = await fetchCart();
          setBadgeCount(cart.item_count);
          await renderDrawerFromSection();
        } catch (err) {
          // ignore
        }
        openDrawer();
      })();
    }, true);
  }

document.addEventListener('DOMContentLoaded', function () {
    initDrawerDelegation();
    initGlobalATCInterceptor();
    initCartIconInterceptor();
  });
})();
